var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_765_19182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 1.6665C5.3988 1.6665 1.66797 5.39734 1.66797 9.99984C1.66797 14.6023 5.3988 18.3332 10.0013 18.3332C14.6038 18.3332 18.3346 14.6023 18.3346 9.99984C18.3346 5.39734 14.6038 1.6665 10.0013 1.6665Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.55859 15.2883C3.55859 15.2883 5.41609 12.9167 9.99943 12.9167C14.5828 12.9167 16.4411 15.2883 16.4411 15.2883M9.99943 10C10.6625 10 11.2984 9.73661 11.7672 9.26777C12.236 8.79893 12.4994 8.16304 12.4994 7.5C12.4994 6.83696 12.236 6.20107 11.7672 5.73223C11.2984 5.26339 10.6625 5 9.99943 5C9.33639 5 8.7005 5.26339 8.23166 5.73223C7.76282 6.20107 7.49943 6.83696 7.49943 7.5C7.49943 8.16304 7.76282 8.79893 8.23166 9.26777C8.7005 9.73661 9.33639 10 9.99943 10Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_765_19182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.f97ea900.svg";
export { ForwardRef as ReactComponent };